import { render, staticRenderFns } from "./AssistantProfile.vue?vue&type=template&id=471f1e02&"
import script from "./AssistantProfile.vue?vue&type=script&lang=ts&"
export * from "./AssistantProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AssistantProfile.vue?vue&type=style&index=0&id=471f1e02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports